import { t as trash, g as textSeparator, o as opportunity, h as clock, i as calendar, s as search, j as ellipsisV, k as infoCircle, l as angleDown, m as angleUp, d as angleInlineEnd, c as angleInlineStart, n as spinner, p as check, q as exclamationTriangle, r as exclamation, u as externalLink, v as close } from '../localIcons-9_jhfe7X.js';
import { a as amznAdsStormLogo } from '../brandIcons-B4Znd6XL.js';
import { a as angleDoubleRight, b as angleDoubleLeft } from '../classicIcons-CHpXglL2.js';

const commonIconManifest = {
  close: close.icon,
  'external-link': externalLink.icon,
  exclamation: exclamation.icon,
  'exclamation-triangle': exclamationTriangle.icon,
  check: check.icon,
  spinner: spinner.icon,
  'angle-inline-start': angleInlineStart.icon,
  'angle-inline-end': angleInlineEnd.icon,
  'angle-up': angleUp.icon,
  'angle-down': angleDown.icon,
  'info-circle': infoCircle.icon,
  'amzn-ads-storm-logo': amznAdsStormLogo.icon,
  'ellipsis-v': ellipsisV.icon,
  search: search.icon,
  'angle-double-left': angleDoubleLeft.icon,
  'angle-double-right': angleDoubleRight.icon,
  calendar: calendar.icon,
  clock: clock.icon,
  opportunity: opportunity.icon,
  'text-separator': textSeparator.icon,
  trash: trash.icon
};

export { commonIconManifest as c };
//# sourceMappingURL=commonIconManifest-CqPSXE0Q.js.map
